import React, { useEffect, useState } from 'react';
import Breadcrumb from '../components/ui/Breadcrumb';
import Input from '../components/ui/Input';
import Select from '../components/ui/Select';
import Button from '../components/ui/Button';
import api from '../utils/api';

const Profile = () => {
  const [profile, setProfile] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    sex: '',
    address: '',
    dateOfBirth: '',
    profilePicture: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/me');
        setProfile(prev => ({ ...prev, ...data }));
      } catch (e) {
        console.error('Failed to load profile', e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const handleChange = (field, value) => {
    setProfile(p => ({ ...p, [field]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put('/me', profile);
    } catch (e) {
      console.error('Failed to save profile', e);
    } finally { setSaving(false); }
  };

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const form = new FormData();
      form.append('file', file);
      const { data } = await api.post('/file', form, { headers: { 'Content-Type': 'multipart/form-data' } });
      const imageUrl = data?.url;
      if (imageUrl) {
        await api.put('/profile-picture', { imageUrl });
        setProfile(p => ({ ...p, profilePicture: imageUrl }));
      }
    } catch (e) {
      console.error('Upload failed', e);
    } finally { setUploading(false); }
  };

  if (loading) return null;

  return (
    <div className="w-full px-3 sm:px-4 lg:px-6 py-4 sm:py-6 lg:py-8">
      <Breadcrumb />
          <h1 className="text-2xl sm:text-3xl font-semibold text-foreground mb-4">Your Profile</h1>
          <div className="bg-card border border-border rounded-lg p-4 sm:p-6 space-y-4 sm:space-y-6">
            <div className="flex items-center space-x-4">
              <img src={profile.profilePicture || '/assets/images/no_image.png'} alt="Profile" className="w-14 h-14 sm:w-16 sm:h-16 rounded-full object-cover border" />
              <div>
                <input type="file" accept="image/*" onChange={handleUpload} />
                {uploading && <div className="text-sm text-muted-foreground">Uploading...</div>}
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Input label="First name" value={profile.firstname || ''} onChange={(e) => handleChange('firstname', e.target.value)} />
              <Input label="Last name" value={profile.lastname || ''} onChange={(e) => handleChange('lastname', e.target.value)} />
              <Input label="Email" value={profile.email || ''} disabled />
              <Input label="Phone" value={profile.phone || ''} onChange={(e) => handleChange('phone', e.target.value)} />
              <Select label="Sex" options={[{value:'',label:'Select'},{value:'male',label:'Male'},{value:'female',label:'Female'}]} value={profile.sex || ''} onChange={(v) => handleChange('sex', v)} />
              <Input label="Date of Birth" type="date" value={profile.dateOfBirth || ''} onChange={(e) => handleChange('dateOfBirth', e.target.value)} />
              <div className="md:col-span-2">
                <Input label="Address" value={profile.address || ''} onChange={(e) => handleChange('address', e.target.value)} />
              </div>
            </div>
            <div className="pt-2">
              <Button variant="default" onClick={handleSave} loading={saving} disabled={saving}>Save Changes</Button>
            </div>
          </div>
        </div>
  );
};

export default Profile;
